export default __webpack_public_path__ + "static/media/zoom-in-24.4868c1a0.svg";